const SOC2_ATTESTED_PROVIDERS = new Set(["openai", "openai_realtime", "google", "cartesia", "azure", "deepgram", "prim"]);

export function isSOC2Attested(providerId: string): boolean {
  return SOC2_ATTESTED_PROVIDERS.has(providerId.toLowerCase());
}
